let viewportFrame = null;

const syncViewportHeight = () => {
  viewportFrame = null;

  const viewportHeight = window.visualViewport?.height || window.innerHeight;

  document.documentElement.style.setProperty('--vh', `${viewportHeight * 0.01}px`);
};

const requestViewportHeightSync = () => {
  if (viewportFrame !== null) {
    return;
  }

  viewportFrame = window.requestAnimationFrame(syncViewportHeight);
};

syncViewportHeight();

window.addEventListener('resize', requestViewportHeightSync, { passive: true });
window.addEventListener('orientationchange', requestViewportHeightSync, { passive: true });
window.visualViewport?.addEventListener('resize', requestViewportHeightSync, { passive: true });
window.visualViewport?.addEventListener('scroll', requestViewportHeightSync, { passive: true });
